import { atom } from 'jotai'

/**
 * App-init slice state — a single boolean flag, `false` until the app mounts, then set `true`
 * by StoreProvider. Fully on Jotai: the Redux reducer/saga and the bridge mirror have been
 * retired, so this atom is the source of truth.
 */
export type AppInitState = boolean;

export const appInitInitialState: AppInitState = false

// Base atom — the source of truth for whether the app has initialised.
export const appInitAtom = atom<AppInitState>(appInitInitialState)

// Derived read atom — exposes whether the app has finished initialising.
export const appInitialisedAtom = atom((get) => get(appInitAtom))

// Write atom — flips the flag to `true` once the app has mounted.
export const setAppInitialisedAtom = atom(null, (_get, set) => {
  set(appInitAtom, true)
})
